import { MODULE_NAME as BILLING_MODULE } from 'modules/billing-and-payments/config/routes';
import { REPORT_PERMISSION } from '../../../../../config/reportPermissions';
import * as FIELDS from '../../fields';
import { REPORT_PRESET } from '../../pickers';
import { columnDefs } from './columnDefinitions';
import { PAYMENTS_REPORT_ID } from './paymentsReportId';
import { defaultColumns } from './reportPresets';

export const paymentsReportConfig = {
    id: PAYMENTS_REPORT_ID,
    label: 'Payments',
    permissions: [REPORT_PERMISSION.BUDGET_MANAGEMENT_VIEW],
    module: BILLING_MODULE,
    endpoint: 'billing/payment-history',
    rowIdField: FIELDS.BILLING_DATE.field,
    columnsDef: columnDefs,
    presets: {
        [REPORT_PRESET.DEFAULT]: { columns: defaultColumns },
    },
    footerColumnDef: [],
    autoFitColumnsToScreen: true,
};
